import { render, staticRenderFns } from "./ProductDetailsPage.vue?vue&type=template&id=7a475813&"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports